import { CellProps, Toggle, Table } from "rsuite";
import { useState } from "react";
import { CustomModal } from "../modal/customModal.component";
import { Link, useNavigate } from "react-router-dom";
import { AppRoutesUI } from "../../config/appRoutes";
import { SvgEdit } from "../../assets/icons";
import { SvgBin } from "../../assets/icons";
import { ApiSuperAdmin } from "../../core/apis/superAdmin";
import { showSuccessToast, showErrorToast } from "../generic/toast.component";

const { Cell } = Table;

export const ActionCell = ({
  rowData,
  statusChange,
  onDeleteChange,
  ...props
}: CellProps & {
  statusChange: (id: string, isActive: boolean) => void;
  onDeleteChange: (id: string) => void;
}) => {
  const navigate = useNavigate();
  const [statusLoading, setStatusLoading] = useState(false);

  const handleActiveStatus = async (id: string) => {
    setStatusLoading(true);
    try {
      await ApiSuperAdmin.activeStatus(id, !rowData.IsActive);
      statusChange(id, !rowData.IsActive);
      navigate(AppRoutesUI.SuperAdmin.SuperAdminList());
      if (rowData.IsActive === true) {
        showSuccessToast("SuperAdmin Deactivated successfully");
      } else {
        showSuccessToast("SuperAdmin Activated successfully");
      }
    } catch (error: any) {
      showErrorToast(error.response?.data?.Message || error.message);
    }
    setStatusLoading(false);
  };

  return (
    <Cell {...props}>
      <div className="d-flex align-items-center justify-content-center ms-3 px-5">
        <Link
          to={AppRoutesUI.SuperAdmin.SuperAdminEditById(rowData.Id)}
          state={rowData.Id}
          className="me-2"
        >
          <SvgEdit />
        </Link>
        <CustomModal
          component={<SvgBin />}
          title="Delete Super Admin"
          okButton="Delete"
          onOk={() => onDeleteChange(rowData.Id)}
        >
          <div>
            <p>Are you sure you want to delete this Super Admin?</p>
          </div>
        </CustomModal>
        <Toggle
          onChange={() => handleActiveStatus(rowData.Id)}
          checked={rowData.IsActive}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          className="ms-2"
          loading={statusLoading}
        />
      </div>
    </Cell>
  );
};
